import { Typography } from "@material-ui/core";
import { memo } from "react";
import { ClickHereLink, SupportGridChild } from "../styles/Boleto";
import Attendant from "./Icones/Attendant";

const Support = () => (
  <SupportGridChild>
    <Attendant size={80} />
    <Typography>
      Precisa de ajuda?{" "}
      <ClickHereLink href="https://www.qyon.com/suporte/" target={"_blank"}>
        CLIQUE AQUI
      </ClickHereLink>{" "}
      e fale com o nosso Suporte!
    </Typography>
  </SupportGridChild>
);

export default memo(Support);
